export default __webpack_public_path__ + "static/media/Introduction to TCP_IP by Yonsei University.b0b65b47.pdf";